const Monsters = {
  "slime-field": [
    {
      name: "슬라임",
      maxHp: 5,
      hp: 5,
      atk: 1,
      gold: 1,
      img: "슬라임.gif",
      dead: "슬라임_dead.png",
    },
    {
      name: "파란 슬라임",
      maxHp: 10,
      hp: 10,
      atk: 3,
      gold: 3,
      img: "파란_슬라임.gif",
      dead: "파란_슬라임_dead.png",
    },
    {
      name: "빨간 슬라임",
      maxHp: 15,
      hp: 15,
      atk: 5,
      gold: 6,
      img: "빨간_슬라임.gif",
      dead: "빨간_슬라임_dead.png",
    },
    {
      name: "킹 슬라임",
      maxHp: 30,
      hp: 30,
      atk: 10,
      gold: 15,
      img: "킹_슬라임.gif",
      dead: "킹_슬라임_dead.png",
    },
  ],
  "golem-canyon": [
    {
      name: "빨간 슬라임",
      maxHp: 15,
      hp: 15,
      atk: 5,
      gold: 6,
      img: "빨간_슬라임.gif",
      dead: "빨간_슬라임_dead.png",
    },
    {
      name: "골렘",
      maxHp: 25,
      hp: 25,
      atk: 10,
      gold: 15,
      img: "golem.gif",
      dead: "golem_dead.png",
    },
    {
      name: "상급 골렘",
      maxHp: 40,
      hp: 40,
      atk: 15,
      gold: 25,
      img: "senior_golem.gif",
      dead: "senior_golem_dead.png",
    },
    {
      name: "대장 골렘",
      maxHp: 60,
      hp: 60,
      atk: 20,
      gold: 45,
      img: "leader_golem.gif",
      dead: "leader_golem_dead.png",
    },
    {
      name: "언데드 골렘",
      maxHp: 100,
      hp: 100,
      atk: 30,
      gold: 100,
      img: "undead_golem.gif",
      dead: "undead_golem_dead.png",
    },
  ],
  "wyvern-cave": [
    {
      name: "대장 골렘",
      maxHp: 60,
      hp: 60,
      atk: 20,
      gold: 45,
      img: "leader_golem.gif",
      dead: "leader_golem_dead.png",
    },
    {
      name: "와이번",
      maxHp: 80,
      hp: 80,
      atk: 25,
      gold: 70,
      img: "wyvern.gif",
      dead: "wyvern_dead.png",
    },
    {
      name: "아이스 와이번",
      maxHp: 130,
      hp: 130,
      atk: 40,
      gold: 150,
      img: "ice_wyvern.gif",
      dead: "ice_wyvern_dead.png",
    },
    {
      name: "파이어 와이번",
      maxHp: 200,
      hp: 200,
      atk: 65,
      gold: 300,
      img: "fire_wyvern.gif",
      dead: "fire_wyvern_dead.png",
    },
    {
      name: "에인션트 와이번",
      maxHp: 500,
      hp: 500,
      atk: 100,
      gold: 1000,
      img: "ancient_wyvern.gif",
      dead: "ancient_wyvern_dead.png",
    },
  ],
};

export default Monsters;
